import React from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import pressToolsImg from "../Assets/Images/press-tools.jpg";
import dieMakingImg from "../Assets/Images/die-making.jpg";
import formingMachineImg from "../Assets/Images/forming-machine.jpg";
import inspectionImg from "../Assets/Images/inspection.jpg";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Helmet } from "react-helmet";

const PressTools = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Press Tools | Delta Engineering</title>
        <meta
          name="description"
          content="High-precision press tools for stamping and forming sheet metal, automotive parts, electrical enclosures, busbars, and switchgear components. Built with advanced CAD/CAM technology for accuracy and efficiency."
        />
        <meta
          name="keywords"
          content="Press Tools, Precision Press Tools, Sheet Metal Press Tools, Stamping Tools, Die Making, CNC Press Tooling, Busbar Stamping Tools, Switchgear Tools, Automotive Press Tools, Electrical Panel Tooling"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Press Tools | Delta Engineering" />
        <meta
          property="og:description"
          content="Precision-crafted press tools designed for high-performance stamping and forming operations. Ideal for automotive, electrical, and industrial applications."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/press-tools"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/press-tools.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Press Tools | Delta Engineering" />
        <meta
          name="twitter:description"
          content="High-precision press tools for reliable stamping and forming operations in automotive, switchgear, and electrical manufacturing."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/press-tools.jpg"
        />
      </Helmet>

      <section className="productbanner1 d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">
          <Row className="justify-content-center">
            <Col lg={8} className="hero-content text-center">
              <h2
                className="hero-title"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <span className="blue-text"> Press </span>{" "}
                <span className="white-text">Tools</span>
              </h2>
              <p
                className="hero-subtitle"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                Precision-crafted press tools for high-performance stamping and
                forming operations
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-3 bg-light" style={{ position: "relative" }}>
        <Button onClick={() => navigate("/ourproducts")} className="back-btn">
          <IoMdArrowRoundBack className="back-icon" />
          Back
        </Button>
        <Container>
          <Row className="text-center mb-4">
            <Col>
              <h3 className="fw-bold section-title">
                Press Tools
                <span className="title-underline"></span>
              </h3>
            </Col>
          </Row>

          <Row className="align-items-center mb-4">
            <Col md={4} className="mb-3 mb-md-0">
              <Image src={pressToolsImg} alt="Press Tools" fluid rounded />
            </Col>
            <Col md={8}>
              <p
                className="text-muted"
                style={{ lineHeight: "1.8", textAlign: "justify" }}
              >
                At Delta Engineering Metal Company, we specialize in
                high-precision press tools designed for manufacturing sheet
                metal and stamped components. Built using the latest CAD/CAM
                technology, our tools ensure accurate forming, consistent
                output, and minimal downtime during production.
              </p>
              <p
                className="text-muted"
                style={{ lineHeight: "1.8", textAlign: "justify" }}
              >
                Whether you're producing intricate parts for automotive,
                electrical enclosures, or busbar components, our tools are built
                to meet high-volume demands with repeatability and reliability.
              </p>
            </Col>
          </Row>

          <Row className="text-center mb-4">
            <Col>
              <h3 className="fw-bold section-title">
                Our Facilities
                <span className="title-underline"></span>
              </h3>
              <p className="text-muted">
                Explore our in-house capabilities for designing and
                manufacturing precision press tools.
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            <Col md={4}>
              <Image
                src={dieMakingImg}
                alt="Die Making Facility"
                fluid
                rounded
                className="mb-3"
              />
              <h5 className="fw-bold">Tool & Die Workshop</h5>
              <p className="text-muted">
                Equipped with modern CNC and EDM machinery for accurate die
                design and manufacturing.
              </p>
            </Col>
            <Col md={4}>
              <Image
                src={formingMachineImg}
                alt="Forming Machine"
                fluid
                rounded
                className="mb-3"
              />
              <h5 className="fw-bold">Forming Press Machines</h5>
              <p className="text-muted">
                High-speed presses with automated feeders for large volume
                stamping operations.
              </p>
            </Col>
            <Col md={4}>
              <Image
                src={inspectionImg}
                alt="Inspection Lab"
                fluid
                rounded
                className="mb-3"
              />
              <h5 className="fw-bold">Inspection & Quality Control</h5>
              <p className="text-muted">
                All parts undergo rigorous quality checks with micrometers,
                CMMs, and vision systems.
              </p>
            </Col>
          </Row>

          <Row className="mb-5">
            <Col>
              <h4 className="fw-bold text-decoration-underline">
                Applications
              </h4>
              <ul className="text-muted" style={{ lineHeight: "1.8" }}>
                <li>Automotive Sheet Metal Component Manufacturing</li>
                <li>Electrical Panel and Enclosure Fabrication</li>
                <li>Busbar and Connector Forming</li>
                <li>Transformer and Switchgear Part Production</li>
                <li>OEM & Custom Product Stamping</li>
                <li>Precision Parts for Consumer Electronics</li>
                <li>Renewable Energy Equipment Components</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PressTools;
